import { Directive } from "@angular/core";
import { AutodeskViewerDto } from "@commonInterfaces/AutodeskViewerModel";
import { ViewGroupItemDto } from "@interfaces/HttpClient/CatalogApiModels";
import { CatalogItemFolderViewDto, CatalogViewContactListDto, CatalogViewGroupDto, DgnbDto, SentinelDto } from "@interfaces/HttpClient/CatalogApiCatalogViewModels";

@Directive()
export abstract class CatalogViewServiceBase {
	abstract getFolderView(catalogGuids: string[], catalogKey?: string): Promise<CatalogItemFolderViewDto[]>
	abstract getCatalogMeta(key: string): Promise<CatalogViewGroupDto>
	abstract getContactPersonsView(catalogKey?: string): Promise<CatalogViewContactListDto>
	abstract getDgnbSustainabilityData(catalogItemGuid: string): Promise<DgnbDto>
	abstract getSentinelSustainabilityData(catalogItemGuid: string): Promise<SentinelDto>
	abstract getAttachments(): ViewGroupItemDto[];
	abstract setAttachments(attachments: ViewGroupItemDto[]);
	abstract getAutodeskViewerSource(attachmentId: number): Promise<AutodeskViewerDto>
}
